
<div color="info-secondary" valg-message-bar 
  *ngIf="isShown()">
  <span class="text--500">{{ 'infobox.result_summary.title' | translate }} </span>
  <ul>
    <li>
    {{'infobox.result_summary.precount' | translate : {
        preliminaryResults: resultSummary?.preliminaryResults,
        pollingAreasCount: resultSummary?.pollingAreasCount
      }
    }}
    </li>
    <li>
    {{'infobox.result_summary.finecount' | translate : {
        finalResults: resultSummary?.finalResults,
        pollingAreasCount: resultSummary?.pollingAreasCount
      }
    }}
    </li>
  </ul>
</div>